import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'
const getTranslateMasterFilters = function () {
  return {
    distributor: { label: i18n.t('distributors.entity_name'), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
    cif: { label: i18n.t('companies.cif').toLowerCase(), value: '' },
    name: { label: i18n.t('companies.companyName'), value: '' },
    direccion: { label: i18n.t('address.location'), value: '' },
    registro_mercantil: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
    codigo_postal: { label: i18n.t('address.codigo_postal'), value: '' },
    telefono: { label: i18n.t('address.telefono'), value: '' },
    pais: { label: i18n.t('address.pais'), value: '' }, 
  }
}
const getTranslateColumns = () => [
  { field: 'Cliente', title: i18n.t('clients.entity_name'), columnMenu: 'myTemplate', width: '180px', locked: false, hidden: true, only: { roles: [8, 3], } },
  { field: 'Distribuidor', title: i18n.t('distributors.entity_name'), columnMenu: 'myTemplate', width: '180px', locked: false, hidden: true, only: { roles: [3], } },
  { field: 'CIF', title: i18n.t('companies.cif'), columnMenu: 'myTemplate', width: '150px', locked: false },
  { field: 'RazonSocial', title: i18n.t('persons_data.nombre_completo'), columnMenu: 'myTemplate', width: '200px', locked: false },
  { field: 'Direccion', title: i18n.t('address.location'), columnMenu: 'myTemplate', width: '350px', locked: false },
  { field: 'RegistroMercantil', title: i18n.t('contacto.RegisterOfCompaniesLocation'), columnMenu: 'myTemplate', width: '350px', locked: false, hidden: true },
  { field: 'Email', width: '250px', title: i18n.tc('users.email', 1), columnMenu: 'myTemplate', locked: false, hidden: true },
  { field: 'CodigoPostal', title: i18n.t('address.codigo_postal'), columnMenu: 'myTemplate', width: '150px', locked: false, hidden: true },
  { field: 'Telefono', title: i18n.t('address.telefono'), columnMenu: 'myTemplate', width: '150px', locked: false, hidden: true },
  { field: 'CodigoPais', title: i18n.t('address.pais'), format: 'PAISES', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '250px', locked: false, hidden: true },
  {
    field: 'idCliente',
    title: i18n.t('clients.id_client'),
    hidden: true,
    columnMenu: 'myTemplate',
    width: '150px',
    locked: false,
    only: {
      roles: [7, 8, 3],
    }, 
  },
]
const getDefaultForm = () => ({ issuer: '' })
const customState = { form: getDefaultForm() }
const customGetters = {
  form: state => state.form
}
const customActions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}
const mystore = parent({ getTranslateColumns, customState, customGetters, customActions, selectable: true, navigate: false, keepSelection: true, namespaced: true, getTranslateMasterFilters })

export default mystore
